import React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

////////////////////////////////////////////////////////////////////////////////

interface IProps extends TooltipProps {
    light?: boolean;
}

////////////////////////////////////////////////////////////////////////////////

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1]
    },

    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white
    },
}));

export const MprcTooltip: React.FC<IProps> = ({ light = false, ...props }) => {

    if (light) {
        return <LightTooltip {...props} />;
    }

    return <Tooltip {...props} />;
};
